module.exports = __webpack_public_path__ + "img/xay-dung-va-phat-trien.72141743.png";